/**
 * Maps a true score 0–100 to bar fill width 0–100% for display.
 *
 * Linear width makes scores like 5–10 look like a thin vertical stripe (especially with
 * low-band red from getColor). A sqrt curve keeps strict monotonicity (21 > 10 > 5) while
 * making small positives readable — without the old "min 24% for all <20" bug where 10
 * looked wider than 21.
 *
 * @param {number} value - score or capped total (incl. bonus) in 0–100
 * @returns {number} width percentage for the coloured fill
 */
export function getProgressBarFillPercent(value) {
  const v = Math.max(0, Math.min(100, Number(value) || 0));
  if (v <= 0) return 0;
  return 100 * Math.sqrt(v / 100);
}
